define( [
	"../ajax"
], function( jQuery ) {

"use strict";

jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};

return jQuery._evalUrl;

} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/manipulation/_evalUrl.js
 ** module id = 688
 ** module chunks = 0
 **/